import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { track } from "@/lib/analytics";

const WHATSAPP_NUMBER = "5581981739909";
const DEFAULT_MESSAGE = encodeURIComponent(
  "Olá, Carlos! Vim pela página e gostaria de conversar."
);

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${DEFAULT_MESSAGE}`}
      onClick={() => track("whatsapp_click", { location: "floating" })}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Conversar no WhatsApp"
      className={`fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 transition-all duration-500 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <span className="relative flex">
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
        <span className="relative flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5b] text-white pl-5 pr-6 py-4 rounded-full shadow-[0_20px_40px_-10px_rgba(37,211,102,0.45)] transition-all duration-300 hover:scale-[1.03]">
          <MessageCircle size={20} strokeWidth={1.8} fill="currentColor" />
          <span className="hidden sm:inline text-xs uppercase tracking-[0.2em] font-medium">
            Falar agora
          </span>
        </span>
      </span>
    </a>
  );
}
